module.exports = __webpack_public_path__ + "img/newyear_btn_confirm.2af8125a.png";